export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-burst-new-f1b1ab1b2acfa6c81babc5293814316b.svg";